export interface PersonalInfoState {
  names: string;
  firstName: string;
  secondName: string;
  firstLastname: string;
  secondLastname: string;
  birthDate: string;
  rfc: string;
  phone: string;
  email: string;
}

export interface DataPersonalInfoState {
  person: PersonalInfoState;
  isLoading: boolean;
}
export interface SelectData {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
}
export interface SelectedData {
  id: string;
  value: string;
}

export const initialState: DataPersonalInfoState = {
  person: {
    names: '',
    firstName: '',
    secondName: '',
    firstLastname: '',
    secondLastname: '',
    birthDate: '',
    rfc: '',
    phone: '',
    email: '',
  },
  isLoading: false,
};
